export default __webpack_public_path__ + "static/media/SG-Yellow-0002.5c52bc7f.png";